(() => {
  const key = '__visitorShippingGeoV2';
  if (window[key]) {
    window[key].render();
    return;
  }
  let countryCode = '';
  let pending;
  const selector = '[data-visitor-shipping]';

  function render() {
    document.querySelectorAll(selector).forEach(row => {
      const label = row.querySelector('[data-shipping-label]');
      const flag = row.querySelector('.visitor-shipping__flag');
      if (!label || !flag) return;
      let countryName = countryCode;
      if (countryCode) {
        try {
          countryName = new Intl.DisplayNames([document.documentElement.lang || 'en'], {type: 'region'}).of(countryCode);
        } catch (_) {}
        countryName = ({US: 'US', GB: 'UK'})[countryCode] || countryName;
      }
      const text = countryCode
        ? row.dataset.shippingTemplate.replace('__COUNTRY__', countryName)
        : row.dataset.shippingFallback;
      if (label.textContent !== text) label.textContent = text;
      const emoji = countryCode ? String.fromCodePoint(...[...countryCode].map(c => 127397 + c.charCodeAt(0))) : '';
      if (flag.textContent !== emoji) flag.textContent = emoji;
      flag.hidden = !countryCode;
      row.dataset.detectedCountry = countryCode;
    });
  }

  function detect() {
    if (pending) return pending;
    countryCode = '';
    render();
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    pending = fetch('https://api.country.is/', {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      cache: 'no-store',
      signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('Country unavailable');
      return response.json();
    }).then(data => {
      const code = typeof data.country === 'string' ? data.country.toUpperCase() : '';
      if (!/^[A-Z]{2}$/.test(code) || ['XX', 'ZZ', 'EU', 'T1', 'A1', 'A2', 'O1'].includes(code)) return;
      countryCode = code;
    }).catch(() => {}).finally(() => {
      clearTimeout(timer);
      pending = undefined;
      render();
    });
    return pending;
  }

  window[key] = {render};
  function start() {
    render();
    detect();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) render();
    }).observe(document.body, {childList: true, subtree: true});
  }
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', event => { if (event.persisted) detect(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
